import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import * as React from "react";
import theme from "../../theme";
import { Users } from "./Users";
import useTableStyles from "../../styles/useTableStyles";
import { ShopUsers } from "./ShopUsers";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFeaturePermissions,
  getModulePermissions,
} from "../../util/permissions";
import { useAppSelector } from "../../redux/hooks";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

export function AdminSidebar() {
  const tabs: string[] = ["user", "shopUser"];
  const navigate = useNavigate();
  const tabStyes = useTableStyles();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab");
  const [tab, setTab] = React.useState(tabParam || "user");
  const { getUserPermission:getShopUserPermissions} = usePermissionGetter("admin", "shop_user");
  const { getUserPermission:getUserPermissions} = usePermissionGetter("admin", "user");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate("/admin");
    setTab(newValue);
  };
  const  [tabList,setTabList] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (getUserPermissions("read") && !tabList.includes("user")) {
      setTabList(prevTabList => [...prevTabList, "user"]);
    }
    if (getShopUserPermissions("read") && !tabList.includes("shopUser")) {
      setTabList(prevTabList => [...prevTabList, "shopUser"]);
    }
  }, [getUserPermissions, getShopUserPermissions]);

  React.useEffect(() => {
    if (tabParam === null && tabList[0] !== undefined) setTab(tabList[0]);
  }, [tabList]);

  return (
    <Grid
      container
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      overflow={"hidden"}
    >
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        sx={{ background: theme.color?.background }}
      >
        <Grid item display={"flex"} alignItems={"center"} px={2}>
          <Typography
            variant="h6"
            sx={{
              color: theme?.color?.primary,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "700",
            }}
            px={2}
          >
            Admin
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        item
        sx={{ background: theme.color?.background }}
        width={"100%"}
        display={"flex"}
        flexDirection={"column"}
      >
        <Grid
          item
          borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        >
          <Box ml={3}>
            <Tabs
              TabIndicatorProps={{
                style: {
                  backgroundColor: theme.color?.secondary,
                },
              }}
              value={tab}
              onChange={handleChange}
              aria-label="tabs menu"
            >
              {getUserPermissions("read") && (
                <Tab
                  value={"user"}
                  id={"user"}
                  label="User"
                  style={{
                    textTransform: "capitalize",
                    fontFamily: theme.font?.fontFamily.primary,
                    color: tab === "user" ? theme.color?.secondary : undefined,
                  }}
                />
              )}

              {getShopUserPermissions("read") && (
                <Tab
                  value={"shopUser"}
                  id={"shopUser"}
                  label="Shop User"
                  style={{
                    textTransform: "capitalize",
                    fontFamily: theme.font?.fontFamily.primary,
                    color:
                      tab === "shopUser" ? theme.color?.secondary : undefined,
                  }}
                />
              )}
            </Tabs>
          </Box>
        </Grid>
      </Grid>
      <Grid width={"100%"}>{tab === "user" ? <Users /> : <ShopUsers />}</Grid>
    </Grid>
  );
}
